import React, { Fragment } from "react";
import Link from "./link";

const PageHeaderTwo = ({ title, name }) => {
  return (
    <section className="breadcrumb_section bg2 text-center section_padding">
      <ul className="breadcrumb">
        <li>
          <Link href="/">Home</Link>
        </li>
        <li>{name}</li>
      </ul>
      <h1 className="text-white">{title}</h1>
    </section>
  );
};

export default PageHeaderTwo;
